import React, { useState } from "react";
import TopTabComponent from "../../../../../src/components/TopTabComponent/TopTabComponent";
import styles from "./ProductionSchedule.module.css";
import {
  DateInput,
  Dropdown,
  InputField,
  SubmitButton,
} from "../../../../components";
import TextComponent from "../../../../components/textComponent/TextComponent";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import ScheduleComponent from "../../../../components/ScheduleComponent/ScheduleComponent";
import { MdOutlineDateRange } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const ProductionSchedule = () => {
  const navigate = useNavigate();
  const [Category, setCategory] = useState("All");
  const [focusedIcon, setFocusedIcon] = useState(null);

  const options = [
    { id: 1, name: "All" },
    { id: 2, name: "Bread" },
    { id: 3, name: "General pastry" },
    { id: 4, name: "Vienoiserrie" },
    { id: 5, name: "Component" },
    { id: 6, name: "Assembly only" },
  ];

  const scheduleData = [
    {
      id: 1,
      title: "Sourdough",
      category: "mixing",
      tab: "Bread",
      components: [
        {
          id: 1,
          label: "Start Mixing",
          expectedtime: "5:15:00 AM",
          actualtime: "5:20:00 AM",
          isCompleted: false,
        },
        {
          id: 2,
          label: "Bulk Ferments",
          expectedtime: "5:15:00 AM",
          actualtime: "5:20:00 AM",
          isCompleted: true,
        },
        {
          id: 3,
          label: "Bulk Ferments",
          expectedtime: "5:15:00 AM",
          actualtime: "5:20:00 AM",
          isCompleted: false,
        },
      ],
    },
    {
      id: 2,
      title: "Whole Wheat",
      category: "mixing",
      tab: "Bread",
      components: [
        {
          id: 1,
          label: "Start Mixing",
          expectedtime: "5:15:00 AM",
          actualtime: "5:20:00 AM",
        },
        {
          id: 2,
          label: "Bulk Ferments",
          expectedtime: "5:15:00 AM",
          actualtime: "5:20:00 AM",
        },
      ],
    },
    {
      id: 2,
      title: "Whole Wheat",
      category: "mixing",
      tab: "Bread",
      components: [
        {
          id: 1,
          label: "Start Mixing",
          expectedtime: "5:15:00 AM",
          actualtime: "5:20:00 AM",
          isCompleted: true,
        },
        {
          id: 2,
          label: "Bulk Ferments",
          expectedtime: "5:15:00 AM",
          actualtime: "5:20:00 AM",
          isCompleted: true,
        },
      ],
    },
    {
      id: 2,
      title: "Pan Breads ",
      category: "Make Up",
      tab: "General pastry",
      components: [
        {
          id: 1,
          label: "Start Mixing",
          expectedtime: "5:15:00 AM",
          actualtime: "5:20:00 AM",
          isCompleted: true,
        },
        {
          id: 2,
          label: "Bulk Ferments",
          expectedtime: "5:15:00 AM",
          actualtime: "5:20:00 AM",
          isCompleted: false,
        },
      ],
    },
    {
      id: 2,
      title: "Whole Grain",
      category: "Oven",
      tab: "Assembly only",
      components: [
        {
          id: 1,
          label: "Start Mixing",
          expectedtime: "5:15:00 AM",
          actualtime: "5:20:00 AM",
        },
        {
          id: 2,
          label: "Bulk Ferments",
          expectedtime: "5:15:00 AM",
          actualtime: "5:20:00 AM",
        },
      ],
    },
    {
      id: 1,
      title: "Sourdough",
      category: "mixing",
      tab: "Vienoiserrie",
      components: [
        {
          id: 1,
          label: "Start Mixing",
          expectedtime: "5:15:00 AM",
          actualtime: "5:20:00 AM",
          isCompleted: false,
        },
        {
          id: 2,
          label: "Bulk Ferments",
          expectedtime: "5:15:00 AM",
          actualtime: "5:20:00 AM",
          isCompleted: true,
        },
        {
          id: 3,
          label: "Bulk Ferments",
          expectedtime: "5:15:00 AM",
          actualtime: "5:20:00 AM",
          isCompleted: false,
        },
      ],
    },

    {
      id: 1,
      title: "Sourdough",
      category: "mixing",
      tab: "Component",
      components: [
        {
          id: 1,
          label: "Start Mixing",
          expectedtime: "5:15:00 AM",
          actualtime: "5:20:00 AM",
          isCompleted: false,
        },
        {
          id: 2,
          label: "Bulk Ferments",
          expectedtime: "5:15:00 AM",
          actualtime: "5:20:00 AM",
          isCompleted: true,
        },
        {
          id: 3,
          label: "Bulk Ferments",
          expectedtime: "5:15:00 AM",
          actualtime: "5:20:00 AM",
          isCompleted: false,
        },
      ],
    },

    {
      id: 2,
      title: "Whole Wheat",
      category: "cooling",
      tab: "Bread",
      components: [
        {
          id: 1,
          label: "Start Mixing",
          expectedtime: "5:15:00 AM",
          actualtime: "5:20:00 AM",
          isCompleted: true,
        },
        {
          id: 2,
          label: "Bulk Ferments",
          expectedtime: "5:15:00 AM",
          actualtime: "5:20:00 AM",
          isCompleted: false,
        },
      ],
    },

    {
      id: 2,
      title: "Whole Wheat",
      category: "packaging",
      tab: "Bread",
      components: [
        {
          id: 1,
          label: "Start Mixing",
          expectedtime: "5:15:00 AM",
          actualtime: "5:20:00 AM",
          isCompleted: true,
        },
        {
          id: 2,
          label: "Bulk Ferments",
          expectedtime: "5:15:00 AM",
          actualtime: "5:20:00 AM",
          isCompleted: true,
        },
      ],
    },

    {
      id: 2,
      title: "Whole Wheat",
      category: "proofing",
      tab: "Bread",
      components: [
        {
          id: 1,
          label: "Start Mixing",
          expectedtime: "5:15:00 AM",
          actualtime: "5:20:00 AM",
          isCompleted: true,
        },
        {
          id: 2,
          label: "Bulk Ferments",
          expectedtime: "5:15:00 AM",
          actualtime: "5:20:00 AM",
          isCompleted: true,
        },
      ],
    },


  ];

  const [focusedTab, setFocusedTab] = useState(options[0]);

  const handlePrev = () => {
    const currentIndex = options.findIndex(
      (opt) => opt.name === focusedTab.name
    );
    if (currentIndex > 0) {
      setFocusedTab(options[currentIndex - 1]);
      setFocusedIcon("left");
    }
  };

  const handleNext = () => {
    const currentIndex = options.findIndex(
      (opt) => opt.name === focusedTab.name
    );
    if (currentIndex < options.length - 1) {
      setFocusedTab(options[currentIndex + 1]);
      setFocusedIcon("right");
    }
  };

  const formatDate = (date) => {
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yy = String(date.getFullYear()).slice(-2);
    return `${mm} - ${dd} - ${yy}`;
  };


  return (
    <div>
      <div className={styles.productionScheduleMain}>
        <div>
          <TopTabComponent
            options={options}
            focused={focusedTab}
            setFocused={setFocusedTab}
            TopTabListStyle={styles.TopTabListStyle1}
            TabStyle={styles.TabStyle1}
          />
        </div>
        <div className={styles.DateInputDiv}>
          <DateInput
            placeholder={formatDate(new Date())}
            inputClass={styles.DateInput}
            rightIcon={<MdOutlineDateRange />}
          // value={formatDate(new Date())}
          />
        </div>
      </div>

      <div className={styles.ProductionScheduleContainer}>
        <div className={styles.ProductionSchedule}>
          <div>
            <Dropdown
              className={styles.inputNew}
              //   label={"Machine Category"}
              value={Category}
              labelStyle={{ fontSize: 18 }}
              inputStyle={{
                backgroundColor: "#F7F8F9",
                border: "1.5px solid #E8ECF4",
                minWidth: "200px",
              }}
              style={{ color: "black" }}
              options={[
                {
                  value: "All",
                  id: 1,
                },
                {
                  value: "Mixing",
                  id: 2,
                },
                {
                  value: "Make Up",
                  id: 3,
                },
                {
                  value: "Proofing/Chill",
                  id: 4,
                },
                {
                  value: "Oven",
                  id: 5,
                },
                {
                  value: "Cooling",
                  id: 6,
                },
                {
                  value: "Packaging",
                  id: 7,
                },
              ]}
              // onChange={(e) => setCategory(e)}
              onChange={(e) => setCategory(e.value)}
            />
          </div>

          <div className={styles.progBtnDiv}>
            <div>
              <SubmitButton
                title={"Create Order"}
                btnClass={styles.progBtn}
                primary
                onClick={() => navigate('/CreateOrder')}
                btnContainerClass={styles.paramBtnContainer}
              //  onClick={handleAddProgram}
              />
            </div>
            {/* 
            <div className={styles.iconWrapper}>
              <div
                className={`${styles.iconCircle} ${
                  focusedIcon === "left" ? styles.focusedIcon : ""
                }`}
                onClick={handlePrev}
              >
                <FaChevronLeft className={styles.icon} />
              </div>
              <div
                className={`${styles.iconCircle} ${
                  focusedIcon === "right" ? styles.focusedIcon : ""
                }`}
                onClick={handleNext}
              >
                <FaChevronRight className={styles.icon} />
              </div>
            </div> */}
          </div>
        </div>

        <div className={styles.schedulesContainer}>
          {(() => {
            const tabName = focusedTab?.name || "All";
            const tabFiltered =
              tabName.toLowerCase() === "all"
                ? scheduleData
                : scheduleData.filter(
                  (item) =>
                    (item.tab || "").toString().toLowerCase() ===
                    tabName.toLowerCase()
                );

            const categorySelected = (Category || "All").toString();
            const finalFiltered =
              categorySelected.toLowerCase() === "all"
                ? tabFiltered
                : tabFiltered.filter(
                  (item) =>
                    (item.category || "").toString().toLowerCase() ===
                    categorySelected.toLowerCase()
                );

            if (!finalFiltered || finalFiltered.length === 0) {
              return <p className={styles.noDataText}>No Data Found</p>;
            }

            if (categorySelected.toLowerCase() === "all") {
              const categories = [
                ...new Set(finalFiltered.map((it) => it.category)),
              ];

              return categories.map((category) => (
                <div key={category} className={styles.categoryBlock}>
                  <TextComponent
                    fontFamily={"Inter-semiBold"}
                    className={styles.categoryTitle}
                    text={category}
                  />

                  <div className={styles.gridContainer}>
                    {finalFiltered
                      .filter((data) => data.category === category)
                      .map((item) => (
                        <div
                          key={item.id + item.title}
                          className={styles.scheduleCard}
                        >
                          <TextComponent
                            fontFamily={"Inter-semiBold"}
                            className={styles.recipeTitle}
                            text={item.title}
                          />
                          {item.components.map((comp) => (
                            // <ScheduleComponent
                            //   key={comp.id + (comp.label || "")}
                            //   expectedtime={comp.expectedtime}
                            //   label={comp.label}
                            //   actualtime={comp.actualtime}
                            //   labelClass={styles.scheduleLabel}
                            //   ScheduleActualTimeStyle={`${styles.ScheduleActualTimeStyle} ${comp.isCompleted ? styles.completed : styles.incomplete
                            //     }`}
                            // />

                            <ScheduleComponent
                              key={comp.id + (comp.label || "")}
                              showEdit={true}
                              expectedtime={comp.expectedtime}
                              label={comp.label}
                              actualtime={comp.actualtime}
                              labelClass={styles.scheduleLabel}
                              ScheduleActualTimeStyle={`${styles.ScheduleActualTimeStyle
                                } ${comp.isCompleted
                                  ? styles.completed
                                  : styles.incomplete
                                }`}
                            />
                          ))}
                        </div>
                      ))}
                  </div>
                </div>
              ));
            }

            return (
              <div className={styles.categoryBlock}>
                <TextComponent
                  fontFamily={"Inter-semiBold"}
                  className={styles.categoryTitle}
                  text={categorySelected}
                />
                <div className={styles.gridContainer}>
                  {finalFiltered.map((item) => (
                    <div
                      key={item.id + item.title}
                      className={styles.scheduleCard}
                    >
                      <TextComponent
                        fontFamily={"Inter-semiBold"}
                        className={styles.recipeTitle}
                        text={item.title}
                      />
                      {item.components.map((comp) => (
                        <ScheduleComponent
                          key={comp.id + (comp.label || "")}
                          expectedtime={comp.expectedtime}
                          label={comp.label}
                          actualtime={comp.actualtime}
                          labelClass={styles.scheduleLabel}
                          // ScheduleActualTimeStyle={styles.ScheduleActualTimeStyle}
                          ScheduleActualTimeStyle={`${styles.ScheduleActualTimeStyle
                            } ${comp.isCompleted
                              ? styles.completed
                              : styles.incomplete
                            }`}
                        />
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            );
          })()}
        </div>
      </div>
    </div>
  );
};

export default ProductionSchedule;
